;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { normalizeLogInput } from './normalize-log-input'
import { redactSensitiveFields } from './redact'
import {
  resolveRuntimeBindings,
  RuntimeBindingsProvider,
} from './runtime-bindings'
import { LogContext, LogInput } from './types'

/**
 * Factory to create a pipeline that runs all the necessary transforms on log input before it is ready for output.
 *
 * It will:
 *  - normalize the input to a standardized structure
 *  - add static data bindings to the log payload
 *  - resolve runtime bindings from the runtime bindings providers and add them to the log payload
 *  - redact sensitive fields from the log payload
 *
 */
export function createLogPipeline({
  staticBindings = {},
  runtimeBindingsProviders,
}: {
  staticBindings?: Record<string, unknown>
  runtimeBindingsProviders?: RuntimeBindingsProvider[]
}) {
  return async (logInput: LogInput, context?: LogContext) => {
    const normalizedInput = normalizeLogInput(logInput, context)

    const runtimeBindings = await resolveRuntimeBindings({
      providers: runtimeBindingsProviders,
    })

    return {
      ...normalizedInput,
      ...redactSensitiveFields({ ...staticBindings, ...runtimeBindings }),
    }
  }
}
